/**
 * 网络来源组件
 * zxw
 * 创建时间：2026-01-20
 */

import {
    Drawer,
    Typography,
    Avatar,
    Space,
} from 'antd';

import { DateStrFormat } from '../../incs/FunHelper';

const { Paragraph } = Typography;
const NetworkSource = (props) => {
    const onClose = () => {
        props.setOpen(false);
    };

    return <>
        <Drawer
            title={"网页搜索 " + props.data.length + " 条结果"}
            mask={false}
            onClose={onClose}
            open={props.open}
            styles={{
                header: {
                    marginTop: 7
                }
            }}
        >
            {
                props.data?.map((item, index) => {
                    if (item.title === '') return;
                    // 
                    const favicon = item?.favicon;
                    const avatar = item?.avatar;
                    const date = item.date;
                    return <div
                        className='network-source'
                        key={index}
                        onClick={() => {
                            window.open(item.link);
                        }}
                    >
                        {
                            favicon || avatar || date ? <Space align="center" style={{ marginBottom: 5, }}>
                                <Avatar size='small' src={favicon || avatar} />
                                <span style={{ fontSize: '12px', color: 'rgba(0,0,0,.6)' }}>{DateStrFormat(date)}</span>
                            </Space> : ''
                        }
                        <h4 style={{ margin: '0 0 5px 0' }}>{item.title}</h4>
                        <Paragraph style={{
                            margin: 0,
                            fontSize: '12px',
                            color: 'rgba(0,0,0,.6)'
                        }} ellipsis={{ rows: 2 }}>{item.snippet}</Paragraph>
                    </div>
                })
            }
        </Drawer>
    </>
}

export default NetworkSource;